import { Button, Loader, TextInput } from "@breward/ui";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import qs from "qs"
import { useStore } from "@breward/store";
import { useApiClient } from "@brewardapp/api-client";

const ResetPasswordForm = ({ onSuccess }) => {
    const location = useLocation();
    const parsedQuery = qs.parse(location?.search, { ignoreQueryPrefix: true });

    const { register, handleSubmit, formState } = useForm();
    const [t] = useTranslation();
    const showNotification = useStore((state) => state.showNotification);

    const api = useApiClient()
    const resetPassword = api.auth.useChangePassword();

    const onSubmit = (values) => {
        resetPassword.mutate({
            token: parsedQuery?.token,
            ...values
        }, {
            onSuccess: () => {
                onSuccess();
                showNotification({
                    type: "success",
                    title: t(
                        "Notifications:ParticipantWeb.passwordChanged.title",
                        "Password set!"
                    ),
                    message: t(
                        "Notifications:ParticipantWeb.passwordChanged.message",
                        "You can login now."
                    ),
                });
            },
            onError: (error) => {
                showNotification({
                    type: "error",
                    title: error?.errors?.[0]?.title,
                    message: error?.errors?.[0]?.detail,
                });
            },
        });
    };

    return (
        <div className="">
            {resetPassword?.isLoading ? (
                <Loader />
            ) : (
                <>
                    <TextInput
                        containerClassName="mb-2"
                        type="password"
                        autoComplete="password"
                        label={t("global:shared.passwordLabel", "Password")}
                        {...register("password", {
                            required: t("global:shared.requiredField", "Field is required")
                        })}
                    />
                    <TextInput
                        containerClassName="mb-2"
                        type="password"
                        autoComplete="password"
                        label={t("global:shared.passwordConfirmationLabel", "Password Confirmation")}
                        {...register("passwordConfirmation", {
                            required: t("global:shared.requiredField", "Field is required")
                        })}
                    />
                    <Button
                        disabled={!formState?.isValid}
                        onClick={() => handleSubmit(onSubmit)()}
                        className="mt-6 text-center text-lg uppercase"
                    >
                        {t("global:shared.resetPassword", "Reset password")}
                    </Button>
                </>
            )}
        </div>
    );
};

export default ResetPasswordForm;
